/**
 * Public host for a chat's temporary domain.
 * Older sites store the code (`my-temp`) and are served at `{code}.finitless.ai`.
 * Cloudflare sites store the full host (`my-temp-chat.my-sites.app`).
 *
 * @param {string | null | undefined} temporalDomain
 * @returns {string | null}
 */
export function getFinitlessTemporalChatUrl(temporalDomain) {
  if (!temporalDomain) {
    return null;
  }

  const host = temporalDomain.includes(".")
    ? temporalDomain
    : `${temporalDomain}.finitless.ai`;

  return `https://${host}`;
}

/**
 * Build the public HTTPS URL for a Finitless-hosted chat site (AI agent site object).
 * Mirrors logic used in AI Agents UI (WidgetConfigModal, AgentCard, AgentSitesSection).
 *
 * @param {{ domain?: string | null, temporal_domain?: string | null, ssl_status?: string | null } | null | undefined} site
 * @returns {string | null}
 */
export function getFinitlessChatSiteUrl(site) {
  if (!site) {
    return null;
  }

  if (site.domain && site.ssl_status === "issued") {
    return `https://${site.domain}`;
  }

  return getFinitlessTemporalChatUrl(site.temporal_domain);
}

/**
 * Chat URL for a Finitless chat agent row from /ai/agents.
 *
 * @param {{ provider?: string | null, provider_type?: string | null, site?: object | null } | null | undefined} agent
 * @returns {string | null}
 */
export function getFinitlessAgentChatUrl(agent) {
  if (agent?.provider !== "finitless" || agent?.provider_type !== "chat") {
    return null;
  }

  return getFinitlessChatSiteUrl(agent.site);
}
